import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import MarketplaceDescription from "components/CreateWizard/Marketplace/MarketplaceDescription";

import * as blueprintReducer from "containers/Blueprint/reducer";

class MarketplaceDescriptionContainer extends React.Component {
  render() {
    return <MarketplaceDescription {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDescription: (descrip) => dispatch(blueprintReducer.updateMarketplaceDescription(ownProps.blueprintId, descrip))
});

const mapStateToProps = (state, ownProps) => ({
  description: blueprintReducer.getMarketplaceDescription(state, ownProps.blueprintId)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(MarketplaceDescriptionContainer);
